// extracted by mini-css-extract-plugin
export default {"root":"SummaryReports_root__pwVaV"};